module.exports = __webpack_public_path__ + "img/outcome_03.65fb6145.png";